/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConfirmSubscriptionAddress } from './ConfirmSubscriptionAddress';
import {
    ConfirmSubscriptionAddressFromJSON,
    ConfirmSubscriptionAddressFromJSONTyped,
    ConfirmSubscriptionAddressToJSON,
    ConfirmSubscriptionAddressToJSONTyped,
} from './ConfirmSubscriptionAddress';

/**
 * 
 * @export
 * @interface ConfirmSubscriptionPaymentRequestOmitted
 */
export interface ConfirmSubscriptionPaymentRequestOmitted {
    /**
     * 
     * @type {ConfirmSubscriptionAddress}
     * @memberof ConfirmSubscriptionPaymentRequestOmitted
     */
    address: ConfirmSubscriptionAddress;
}

/**
 * Check if a given object implements the ConfirmSubscriptionPaymentRequestOmitted interface.
 */
export function instanceOfConfirmSubscriptionPaymentRequestOmitted(value: object): value is ConfirmSubscriptionPaymentRequestOmitted {
    if (!('address' in value) || value['address'] === undefined) return false;
    return true;
}

export function ConfirmSubscriptionPaymentRequestOmittedFromJSON(json: any): ConfirmSubscriptionPaymentRequestOmitted {
    return ConfirmSubscriptionPaymentRequestOmittedFromJSONTyped(json, false);
}

export function ConfirmSubscriptionPaymentRequestOmittedFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfirmSubscriptionPaymentRequestOmitted {
    if (json == null) {
        return json;
    }
    return {
        
        'address': ConfirmSubscriptionAddressFromJSON(json['address']),
    };
}

export function ConfirmSubscriptionPaymentRequestOmittedToJSON(json: any): ConfirmSubscriptionPaymentRequestOmitted {
    return ConfirmSubscriptionPaymentRequestOmittedToJSONTyped(json, false);
}

export function ConfirmSubscriptionPaymentRequestOmittedToJSONTyped(value?: ConfirmSubscriptionPaymentRequestOmitted | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'address': ConfirmSubscriptionAddressToJSON(value['address']),
    };
}

